import { render, staticRenderFns } from "./SignBatchPage.vue?vue&type=template&id=aa466cf0&scoped=true"
import script from "./SignBatchPage.vue?vue&type=script&lang=js"
export * from "./SignBatchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa466cf0",
  null
  
)

export default component.exports